import { ComponentProps, useContext } from 'react';

import { Button } from '../../Button';

import { ModalContext, SIZES } from './context';

function ModalButton({ size, ...props }: ComponentProps<typeof Button>) {
  const { size: contextSize } = useContext(ModalContext);

  return <Button size={size ?? SIZES[contextSize].button} {...props} />;
}

export { ModalButton };
